export class UserProfileCommon {
	public ID: number;
	public Name: string;
	public WorkEmail: string;
	public CellPhone: string;
	public AffiliationRoleList: string[];
	public isAffiliationUpdated: boolean;
}
